export class GameViews {
	// public static readonly LEVEL_REEL_VIEW: string = 'LevelReelView';
	public static readonly EXPANDED_WILD_VIEW: string = 'ExpandedWildView';
	public static readonly RESPIN_VIEW: string = 'RespinView';
	public static readonly REEL_EXPANDER_VIEW: string = 'ReelExpanderView';
	public static readonly FOREGROUND_VIEW: string = 'ForegroundView';
	public static readonly PAYTABLE_VIEW: string = 'PaytableView';
	public static readonly REELPOPUP_VIEW: string = 'ReelPopupView';
	public static readonly PAYTABLE_VIEW_MOBILE: string = 'PaytableViewMobile';
	public static readonly AUTOPLAY_MENU_VIEW: string = 'AutoPlayMenuView';
	public static readonly SETTINGS_VIEW: string = 'SettingsView';
	public static readonly LEVEL_BALL_VIEW: string = 'LevelBallView';
	public static readonly ANNOUNCEMENT_BOARD_VIEW: string = 'AnnouncementBoardView';
	public static readonly CHARACTER_CHOICE_SCREEN_VIEW: string = 'CharacterChoiceScreenView';
	public static readonly CARDS_LEVELLING_SCREEN_VIEW: string = 'CardsLevellingView';
	public static readonly HISTORY_BOX_VIEW: string = 'HistoryBoxView';
	public static readonly KEYS_VIEW: string = 'KeysView';
	public static readonly MERGING_BIG_SYMBOLS_VIEW: string = 'MergingBigSymbolsView';
	public static readonly SPLITTING_BIG_SYMBOLS_VIEW: string = 'SplittingBigSymbolsView';
	public static readonly RANDOM_MULTIPLIER_VIEW: string = 'RandomMultiplierView';
	public static readonly SYMBOLS_EXPLOSION_VIEW: string = 'SymbolsExplosionView';
	public static readonly MIMIC_FREE_SPINS_INTRO_VIEW: string = 'MimicFreeSpinsIntroView';
	public static readonly SCATTER_COUNTER_VIEW: string = 'ScatterCounterView';
	public static readonly STICKY_SYMBOLS_LAYER_VIEW: string = 'StickySymbolsLayerView';
	public static readonly RESPIN_FOREGROUND_VIEW: string = 'RespinForegroundView';
	public static readonly STAR_VIEW: string = 'StarView';
	public static readonly REEL_SCATTERS_VIEW: string = 'ReelScattersView';
	public static readonly REEL_FRAME_VIEW: string = 'ReelFrameView';
	public static readonly TOP_REELS_VIEW: string = 'TopReelsView';
	public static readonly UNDER_TOP_REELS_VIEW: string = 'UnderTopReelsView';
	public static readonly WILD_METER_VIEW: string = 'WildMeterView';
	public static readonly WIN_LINES_PRESENTATION_VIEW: string = 'WinLinesPresentationView';
	public static readonly WIN_FIELD_VIEW: string = 'WinFieldView';
	public static readonly FREE_SPINS_TRIGGER_VIEW: string = 'FreeSpinsTriggerView';
}



// WEBPACK FOOTER //
// ./src/GameViews.ts